import { render, staticRenderFns } from "./sorotecacontainer.vue?vue&type=template&id=3c2d023e&"
import script from "./sorotecacontainer.vue?vue&type=script&lang=js&"
export * from "./sorotecacontainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports